import { render, staticRenderFns } from "./WaitingReservationPopup.vue?vue&type=template&id=51924a72&"
import script from "./WaitingReservationPopup.vue?vue&type=script&lang=js&"
export * from "./WaitingReservationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports